<template>
	<v-card v-if="Object.keys(event).length > 0">
		<v-card-text>
			<h1 class="host-dashboard-title">{{ event.title }}</h1>
			<v-layout row wrap v-if="loadingEvent">
				<v-flex xs12 class="text-xs-center pa-4">
					<h4>Loading Event...</h4>
				</v-flex>
			</v-layout>
			<v-layout row wrap v-else>
				<v-flex xs12 class="pl-3 pr-3 pb-3">
					<v-card>
						<v-card-text>
							<p class="add-event-review-header">Event Page</p>
							<p class="add-event-review-content"><router-link :to="{ name: 'event', params: { slug: event.slug }}">Go to event page</router-link></p>
							<v-divider></v-divider>
							<p class="add-event-review-header">Subtitle</p>
							<p class="add-event-review-content">{{ event.subtitle }}</p>
							<v-divider></v-divider>
							<p class="add-event-review-header">Price</p>
							<p class="add-event-review-content">${{ event.price }}</p>
							<v-divider></v-divider>
							<p class="add-event-review-header">Date</p>
							<p class="add-event-review-content">{{ event.date }}</p>
							<v-divider></v-divider>
							<p class="add-event-review-header">Time</p>
							<p class="add-event-review-content">{{ formattedTime }}</p>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs12 md6>
					<v-layout row wrap>
						<v-flex xs12 class="pa-3">
							<v-card>
								<v-card-title class="mb-1"><b>Attendees</b></v-card-title>
								<v-divider></v-divider>
								<div class="pa-4">
									<p>
										<span>Event is open to</span>
										<span v-for="(r,index) in event.restrictions.provisions" :key="r">
											<span v-if="r === 'occupation_or_interest'">
												people interested in {{ event.restrictions.inputs[r+'_input'] }}<span v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span>
											</span>
											<span v-else-if="r === 'women_only'">
												women only<span v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span>
											</span>
											<span v-else-if="r === 'parents_only'">
												parents with children {{ event.restrictions.inputs.min_child_age }} to {{ event.restrictions.inputs.max_child_age }}<span v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span>
											</span>
											<span v-else-if="r === 'age_range'">
												people between the ages of {{ event.restrictions.inputs.min_age }} to {{ event.restrictions.inputs.max_age }}<span v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span>
											</span>
											<span v-else>{{ r }}<span v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span></span>
										</span>
									</p>
									<!-- Attendees -->
									<h4 class="mb-1">Going</h4>
									<host-event-guest-list :event="event"></host-event-guest-list>
								</div>
							</v-card>
						</v-flex>
						<v-flex xs12 class="pa-3">
							<v-card>
								<v-card-title class="text-xs-center mb-1"><b>Photos</b></v-card-title>
								<v-divider></v-divider>
								<v-card-text>
									<v-layout row wrap>
										<v-flex xs6 class="pa-2">
											<v-card>
												<!-- <v-card-media :src="event.primary_image.image" height="200px"></v-card-media> -->
												<v-img
													:src="event.primary_image.image"
													aspect-ratio="1.7778"
												></v-img>
												<v-card-title>{{ event.primary_image.filename }}<br>Primary Photo</v-card-title>
											</v-card>
										</v-flex>
										<v-flex xs6 class="pa-2" v-for="(photo, index) in event.additional_images" :key="photo.filename + index">
											<v-card>
												<!-- <v-card-media :src="photo.image" height="200px"></v-card-media> -->
												<v-img
													:src="photo.image"
													aspect-ratio="1.7778"
												></v-img>
												<v-card-title>{{ photo.filename }}</v-card-title>
												<v-card-actions>
													<!-- <v-btn>Make primary</v-btn> -->
												</v-card-actions>
											</v-card>
										</v-flex>
									</v-layout>
								</v-card-text>
								<v-card-actions>
									<v-btn color="warning" @click="openEditModal">Request Photo Change</v-btn>
								</v-card-actions>
							</v-card>
						</v-flex>
						<v-flex xs12 class="pa-3">
							<v-card>
								<v-card-title class="text-xs-center mb-1"><b>Event Activity / Add On</b></v-card-title>
								<v-divider></v-divider>
								<v-card-text>
									Add on details
								</v-card-text>
								<v-card-actions>
									<v-btn color="warning" @click="openEditModal">Request Add-On Change</v-btn>
								</v-card-actions>
							</v-card>
						</v-flex>
						<v-flex xs12 class="pa-3">
							<v-card>
								<v-card-title class="text-xs-center mb-1"><b>Printable Materials</b></v-card-title>
								<v-divider></v-divider>
								<v-card-text>
									<host-marketing-materials :event="event"></host-marketing-materials>
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 md6 class="pa-3">
					<v-card>
						<v-card-title class="text-xs-center mb-1"><b>Event Details</b></v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<p class="add-event-review-header">Host Notes</p>
							<p class="add-event-review-content" v-html="newlines(event.notes)"></p>
							<v-divider></v-divider>
							<p class="add-event-review-header">House Rules</p>
							<p class="add-event-review-content" v-html="newlines(event.location_rules)"></p>
							<v-divider></v-divider>
							<p class="add-event-review-header">Description (What to expect)</p>
							<p class="add-event-review-content" v-html="newlines(event.description)"></p>
							<v-divider class="mt-3 mb-3"></v-divider>
							<div class="mb-1"><b>Amenities &amp; Provisions</b></div>
							<p class="add-event-review-header">Provisions</p>
							<choice-field-display class="pb-3" :original="eventProvisionsOptions" :fields="event.provisions.amenities" :inputs="event.provisions.amenitiesInputs"></choice-field-display>
				
							<v-divider class="mt-2 mb-3"></v-divider>

							<p class="add-event-review-header">Event Location Amenities</p>
							<choice-field-display class="pb-3" :original="locationInfoOptions" :fields="event.provisions.provisions" :inputs="event.provisions.infoInputs"></choice-field-display>
						</v-card-text>
						<v-card-actions>
							<v-btn color="warning" @click="openEditModal">Request Event Detail Change</v-btn>
						</v-card-actions>
					</v-card>
				</v-flex>
				<v-flex xs12 class="pa-3">
					<v-card>
						<v-card-title class="text-xs-center mb-1"><b>Admin</b></v-card-title>
						<v-divider></v-divider>
						<v-card-text class="text-xs-right">
							<v-btn @click="openEditModal" color="warning">Request Date/Time Change</v-btn>
							<v-btn @click="openEditModal" color="error">Cancel Event</v-btn>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</v-card-text>
	</v-card>
</template>

<script>
import HostMarketingMaterials from '~/components/hosting/HostMarketingMaterials.vue'
import HostEventGuestList from '~/components/hosting/HostEventGuestList.vue'
import ChoiceFieldInput from '~/components/ChoiceFieldInput'
import ChoiceFieldDisplay from '~/components/ChoiceFieldDisplay'

import {mapActions, mapGetters} from 'vuex'
import { replaceNewlines } from '~/store/util/util'
import {
	locationInfoOptions,
	eventProvisionsOptions,
	eventRestrictionOptions
} from '~/store/util/values'
import { fetchEventBySlug, fetchLocation, fetchAllEvents } from '~/store/api/event_location_api'

export default {
	name: 'host_dashboard_upcoming_events',
	data () {
		return {
			event: {},
			locationInfoOptions: locationInfoOptions,
			eventProvisionsOptions: eventProvisionsOptions,
			loadingEvent: false,
			// Provisions
			editingProvisions: false,
			infoOptions: locationInfoOptions,
			locationInfo: [],
			locationInfoInputs: {},
			amenitiesOptions: eventProvisionsOptions,
			amenities: [],
			amenitiesInputs: {},
			editLocationInfo: false
		}
	},
	beforeRouteEnter(to, from, next) {
		fetchEventBySlug(to.params.slug).then((response) => {
			next(vm => {
				vm.setEvent(response.data)
				if (from.name !== 'host_add_event_submit') {
					vm.previousPage = from
				} else {
					vm.previousPage = {
						path: '/host/dashboard'
					}
				}
			})
		}).catch((error) => {
			console.error(error)
			next({path: '/'})
		})
	},
	beforeRouteUpdate(to, from, next) {
		console.log('beforeRouteUpdate')
		console.log(to.params.slug)
		fetchEventBySlug(to.params.slug).then((response) => {
			console.log('response', response.data)
			this.setEvent(response.data)
			next()
		}).catch((error) => {
			console.error(error)
			next()
		})
	},
	methods: {
		...mapActions([
			'fetchEventPrivate',
			'setEditEventContactFormEvent',
			'setModalProp',
			'setCurrentEvent',
			'setModalOpen',
		]),
		setEvent(event) {
			this.event = event
			this.setCurrentEvent(event)
			this.loadingEvent = false
		},
		openEditModal () {
			this.setEditEventContactFormEvent(-1)
			this.setModalOpen({ prop: 'editEventContactForm', value: true })
		},
		requestEventDetailChange () {
			alert('asdfsa')
		},
		newlines(value) {
			return replaceNewlines(value)
		},
	},
	computed: {
		...mapGetters([
			'user',
			'getEventBySlug',
			'getModalProp'
		]),
		formattedTime() {
			if (this.event) {
				let start = this.timeToAMPM(this.event.time_start)
				let end = this.timeToAMPM(this.event.time_end)

				if (!start || !end) {
					return ''
				}

				let startSuffix = ''
				let endSuffix = ''

				if (start.includes('a')) {
					startSuffix = 'am'
				} else {
					startSuffix = 'pm'
				}

				if (end.includes('a')) {
					endSuffix = 'am'
				} else {
					endSuffix = 'pm'
				}

				return (
					start.split(':')[0] +
					startSuffix +
					' - ' +
					end.split(':')[0] +
					endSuffix
				)
			}
			return ''
		},
		timeToAMPM() {
			return timeString => {
				let time = timeString
					.toString()
					.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [timeString]
				if (time.length > 1) {
					time = time.slice(1)
					if (time.length > 3) {
						time.pop()
					}
					time[5] = +time[0] < 12 ? 'am' : 'pm'
					time[0] = +time[0] % 12 || 12
				}
				return time.join('')
			}
		},
	},
	components: {
		HostMarketingMaterials,
		HostEventGuestList,
		ChoiceFieldDisplay,
		ChoiceFieldInput
	}
}
</script>

<style>

</style>
